// Module
var code = "<h3>{{availableMetrics.IsServerRelated(selectedMetric) ? 'Server' : 'App'}} Metrics</h3> <ul class=\"collection\"> </ul>";
// Exports
export default code;